module.exports = __webpack_public_path__ + "img/icon-event-responsive-marketing.dab9a1f5.png";